import { Typography, type TypographyProps } from "@material-ui/core";

const CardTitle = ({ children }: TypographyProps) => {
  return <Typography variant="h5">{children}</Typography>;
};

export default CardTitle;
